// Generated by Copilot- Start
import DtvTheme, { colorPalette } from "@directv-digital/dds.ui.dtv-theme";

/**
 * Styles for RSN Channel Modal V2 - specifically for teams table
 */
export const rsnModalStyles = {
  tableColHeading: {
    paddingTop: "17px",
    [DtvTheme.breakpoints.between(DtvTheme.breakpoints.values.sm, DtvTheme.breakpoints.values.lg)]: {
      paddingTop: "15px"
    },
    [DtvTheme.breakpoints.down(DtvTheme.breakpoints.values.sm)]: {
      paddingTop: "16px"
    }
  },
  network: {
    border: `1px solid ${colorPalette.neutral[300]}`,
    borderLeft: "0px",
    height: "56px",
    textAlign: "center"
  },
  teams: {
    border: "1px solid #999999",
    borderRight: "0px",
    color: "#454B52",
    textAlign: "center"
  },
  regionalTrHeight: {
    minHeight: "84px",
    height: "100%",
    padding: "20px"
  },
  teamsTr: {
    flex: "1 0 120px",
    textAlign: "center"
  },
  teamsTrIn: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center"
  },
  teamsTrVal: {
    textAlign: "left"
  },
  commonTeamsBodyStyles: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  affTh: {
    height: "56px"
  },
  tableColAffSportHeading: {
    color: "#102641",
    backgroundColor: "#EAF1FA"
  }
};
// Generated by Copilot- End
